export const PhoneType = [
    { id: 'viber', name: 'Viber' },
    { id: 'telegram', name: 'Telegram' }
];
